import Text from "../../../../../../../shared/components/Text";
import { InformationMessage } from "nemuru-components";
import React from "react";
import { PaymentPlanLineStatus } from "@nemuru-eng/js-api-client";

export const PaymentPlanLineResultMessage = ({
  paymentPlanLine,
  resultMessageVariant,
}) => {
  const getValuesByResultMessageVariant = () => {
    switch (resultMessageVariant) {
      case resultMessageVariantType.FLYWIRE:
        return FlywireValuesByPaymentPlanLine[paymentPlanLine.status];
      default:
        return DefaultValuesByPaymentPlanLine[paymentPlanLine.status];
    }
  };

  const values = getValuesByResultMessageVariant();

  return (
    <InformationMessage
      variant={{
        type: values.type,
        icon: (
          <i className="material-icons-outlined" style={{ fontSize: 22 }}>
            {values.icon}
          </i>
        ),
      }}
      isScreenXs={false}
      messageContent={{
        title: <Text tId={values.titleTextId} />,
        body: (
          <>
            <Text tId={values.textId} />
          </>
        ),
      }}
    />
  );
};

const DefaultValuesByPaymentPlanLine = {
  [PaymentPlanLineStatus.PAID]: {
    type: "info",
    icon: "check",
    titleTextId: "PAYMENT_PLAN_LINE_PAID_TITLE",
    textId: "PAYMENT_PLAN_LINE_PAID_TEXT",
  },
  [PaymentPlanLineStatus.PROCESSING]: {
    type: "warning",
    icon: "info",
    titleTextId: "PAYMENT_PLAN_LINE_PROCESSING_TITLE",
    textId: "PAYMENT_PLAN_LINE_PROCESSING_TEXT",
  },
  [PaymentPlanLineStatus.CANCELLED]: {
    type: "warning",
    icon: "info",
    titleTextId: "PAYMENT_PLAN_LINE_CANCELLED_TITLE",
    textId: "PAYMENT_PLAN_LINE_CANCELLED_TEXT",
  },
};

const FlywireValuesByPaymentPlanLine = {
  [PaymentPlanLineStatus.PAID]: {
    type: "info",
    icon: "check",
    titleTextId: "PAYMENT_PLAN_LINE_PAID_TITLE",
    textId: "PAYMENT_RESULT_SUCCESS_TEXT",
  },
  [PaymentPlanLineStatus.PROCESSING]: {
    type: "warning",
    icon: "info",
    titleTextId: "PAYMENT_PLAN_LINE_PROCESSING_TITLE",
    textId: "PAYMENT_PLAN_LINE_PROCESSING_TEXT",
  },
  [PaymentPlanLineStatus.CANCELLED]: {
    type: "warning",
    icon: "info",
    titleTextId: "PAYMENT_PLAN_LINE_CANCELLED_TITLE",
    textId: "PAYMENT_PLAN_LINE_CANCELLED_TEXT",
  },
  [PaymentPlanLineStatus.PENDING]: {
    type: "warning",
    icon: "info",
    titleTextId: "PAYMENT_PLAN_LINE_PENDING_TITLE",
    textId: "PAYMENT_PLAN_LINE_PENDING_TEXT",
  },
};

export const resultMessageVariantType = {
  DEFAULT: "default",
  FLYWIRE: "flywire",
};
